module.exports = __webpack_public_path__ + "img/rushan_1.3535a9e8.jpeg";